<div class="panel-grid" #panelContainer [attr.grid-columns]="data.gridColVal">
    <ng-container *ngFor="let data of data.panelData; let i = index;">
            <div class="adc-panel adc-rounded grid-item" draggable="true" #panelChild id="{{ data.panelId }}" (click)="clickPanel(data.panelId)"
                [ngClass]="{'span-two full-screen' : data.options.fullscreen}"
                [class.droppable]="draggedPanelId && draggedPanelId !== data.panelId"
                (dragstart)="dragStart($event, data.panelId)"
                (dragover)="dragOver($event)" (drop)="drop($event, data.panelId)"
                [attr.grid-value]="data.gridRowSpan">
                <!-- <div class="resize-handle" (mousedown)="startResize($event, data.id)"></div> -->
                <div class="adc-panel-heading">
                    <div class="adc-d-flex adc-align-items-center">
                        <div class="adc-mr10 adc-d-flex" style="color: #fff">
                            <span class="adc-align-self-center material-symbols-outlined adc-mt5">{{ data.titleIcon }}</span>
                            <span><p class="adc-panel-title" title="{{ data.panelTitle }}">{{data.panelTitle}}</p></span>
                        </div>
                    </div>
                    <div class="adc-d-flex adc-gap-3 adc-align-items-center">
                        <ng-content select="[right]"></ng-content>
                        <div class="adc-mt10 adc-mr-10" (click)="reset()" *ngIf="data.showIcons">
                            <div ngClass="{{ data.options.fullscreen ? 'img-fs' : 'adc-panel-icons' }}">
                                <div *ngIf="data.icons.includes('search')">
                                    <div class="adc-srh adc-mb10 adc-mr8 adc-cl-black" *ngIf="data.options.search">
                                        <input placeholder="Search" type="text">
                                        <span class="adc-cl-blck material-symbols-outlined" (click)="search(i)">search</span>
                                    </div>
                                    <!-- <div class="adc-tooltip" data-tooltip="Search" data-position="top"> -->
                                        <span class="material-symbols-outlined" ngClass="{{ data.options.search ? 'search-icon' : 'search-icon-close'}}" (click)="search(i)" *ngIf="!data.options.search">search</span>
                                    <!-- </div> -->
                                </div>
                                <div class="adc-tooltip" data-tooltip="Reload" data-position="top" *ngIf="data.icons.includes('refresh')">
                                    <span class="material-symbols-outlined" (click)="reload(i)">refresh</span>
                                </div>
                                <div class="adc-tooltip full-screen-mob" data-tooltip="Fullscreen" data-position="top" *ngIf="data.icons.includes('fullscreen')">
                                    <span class="material-symbols-outlined" (click)="fullscreen(i)" *ngIf="!data.options.fullscreen">fullscreen</span>
                                </div>
                                <div class="adc-tooltip" data-tooltip="Exit FS" data-position="top" *ngIf="data.icons.includes('fullscreen_exit')">
                                    <span class="material-symbols-outlined" (click)="exitFullscreen(i)" *ngIf="data.options.fullscreen">fullscreen_exit</span>
                                </div>
                                <div class="adc-tooltip" data-tooltip="Close" data-position="top" *ngIf="data.icons.includes('close')">
                                    <span class="material-symbols-outlined" (click)="closePanel(i)">close</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div class="adc-panel-body" (click)="reset()">
                        <div class="loader" *ngIf="data.options.loading"></div>
                        <div class="panel-content" *ngIf="!data.options.loading">
                            <div class="content">
                                <!-- {{ data.content }} -->
                                <div *ngIf="data.panelType === 'grid'">
                                    <table class="adc-table adc-table-striped adc-table-hover adc-border-1">
                                        <thead>
                                            <tr>
                                                <ng-container *ngIf="data && data.content">
                                                    <ng-container *ngIf="data.content.headers">
                                                        <th *ngFor="let data1 of data.content.headers">{{ data1 }}</th>
                                                    </ng-container>
                                                </ng-container>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <ng-container *ngIf="data && data.content">
                                                <ng-container *ngIf="data.content.tableData">
                                                <tr *ngFor="let rowData of data.content.tableData">
                                                    <ng-container *ngIf="rowData">
                                                        <td *ngFor="let cellData of rowData">
                                                            {{ cellData }}
                                                        </td>
                                                    </ng-container>
                                                </tr>
                                                </ng-container>
                                            </ng-container>
                                        </tbody>
                                    </table>
                                </div>
                                <div *ngIf="data.panelType === 'list'">
                                    <adc-list [data]="data.content" type="multiLine" class="adc-w-25"></adc-list>
                                </div>
                                <div *ngIf="data.panelType === 'content'">
                                    <div [innerHTML]="data.content"></div>
                                </div>
                                <div *ngIf="data.panelType === 'chart'">
                                    <div echarts [options]="data.content" class="chart"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    </ng-container>
</div>

